export default {}.install = (Vue) => {
    Vue.directive('preventReClick', {
        bind(el, binding) {
            if (binding.value) {
                el.addEventListener('click', () => {
                    if (!el.disabled) {
                        el.disabled = true;
                        el.style.cursor = 'not-allowed';
                        setTimeout(() => {
                            el.style.cursor = 'pointer';
                            el.disabled = false;
                        }, 1500);
                    }
                });
            }
        }
    });

};